import { IMSDK } from '@/imsdk/index.ts';
// import { ajaxErrorCatch } from '@/utils/errorCatch';
import StringUtils from '@/utils/string';
import globalWin from '@/utils/globalWin.ts';
import { handleLinkClick } from '@/utils/bindlLinkClick.js';
import { ROBOT_REPLY_TYPE } from '@/components-business/MessageBubble/common.js';
import { REPORT_ROBOTNAV_URLCLICK } from '@/utils/api';
const imsdk = IMSDK.create();
// 统一处理机器人消息的点击
export default {
  inject: ['to', 'IMSDKType', 'globalData', 'wpaDetail'],
  methods: {
    /**
     * 营销上报。
     * TOFIX: 有两个问题需要注意：1.机器人导航也有类似的独立上报；2.这需要获取Aio注入的变量，需要注意。
     */
    qidianDAReport(reportObj) {
      if (globalWin.robotTestMode) {
        return;
      }
      const reportMsg = Object.assign({
        robot_nav_conv_type: 4,
        robot_nav_cid: this.to.user_id,
        robot_nav_msg_dir: 2,
        robot_nav_event_type: 2,
        robot_nav_robot_id: Number(this.globalData.reception.robotId || 0),
        wpa_id: this?.wpaDetail?.wpaId ? Number(this.wpaDetail.wpaId) : '',
      }, reportObj);

      console.log('reportMsg-full', reportMsg);
      window.qidianDA('track', 'robot_nav_click', reportMsg);
    },

    handleAction(info, reportData, robotId = '') {
      console.log('上报', info, reportData);

      const action = info.action || 6; // 如果没有设置该值，则是6兜底。
      const url = (info.meta && info.meta.url) || '';
      // 服务评价和结束会话不上报
      const needReport = ![ROBOT_REPLY_TYPE.ACTIVE_FEEDBACK, ROBOT_REPLY_TYPE.CLOSE_SESSION].includes(action);
      // 如果有上报信息，需要处理上报
      if (reportData && needReport) {
        const reportMsg = Object.assign({
          robot_nav_first_menu_id: info.id,
          robot_nav_first_menu_name: info.name,
          robot_nav_action_type: action,
        }, reportData);

        console.log('reportMsg', reportMsg);
        this.qidianDAReport(reportMsg);
      }
      const svrId = 1000003; // 固定值
      // 这里需要用传进来的robotId,不要使用全局的reception.robotId.避免转人工、会话结束等场景导致的机器人ID不准
      // 这里需要对ext进行编码后传递，否则后端在解析的时候对于一些特殊字符会有问题
      const actionUrl = `mqqwpa://im/qdmenu?svrId=${svrId}&robotId=${robotId}&ext=${encodeURIComponent(JSON.stringify(info))}`;

      // 这里要求将 info.meta.type 的值改成String类型，否则走接口上报 报错500
      let updateTypeActionUrl;
      if (info.meta && info.meta.type) {
        const updateTypeInfo = JSON.parse(JSON.stringify(info));
        updateTypeInfo.meta.type = String(updateTypeInfo.meta.type);
        updateTypeActionUrl = `mqqwpa://im/qdmenu?svrId=${svrId}&robotId=${robotId}&ext=${encodeURIComponent(JSON.stringify(updateTypeInfo))}`;
      }

      switch (action) {
        case ROBOT_REPLY_TYPE.IMGTXT:
          // 拉取图文消息
          handleLinkClick(actionUrl);
          break;
        case ROBOT_REPLY_TYPE.WEB:
          // 打开URL
          handleLinkClick(url);
          // 机器人导航 跳转网页的点击上报
          this.urlClickReport(actionUrl);
          break;
        case ROBOT_REPLY_TYPE.KNOWLEDGE:
          // 指定知识库问答。C侧发送一个不可见消息，B侧做出回应。
          globalWin.sendOnlyInvisibleMessage({
            type: 'text',
            content: info.name || info.question || '',
          });
          handleLinkClick(actionUrl);
          break;
        case ROBOT_REPLY_TYPE.HUMAN:
          // 发送不可见的c2b消息。从B侧配置看就是【转人工】操作。
          handleLinkClick(actionUrl);
          break;
        case ROBOT_REPLY_TYPE.ACTIVE_FEEDBACK:
          // 主动评价
          this.$parent.activeFeedback();
          this.urlClickReport(updateTypeActionUrl);
          break;
        case ROBOT_REPLY_TYPE.CLOSE_SESSION:
          // 结束会话
          this.$parent.closeSession();
          this.urlClickReport(updateTypeActionUrl);
          break;
          // 系统事件
        case ROBOT_REPLY_TYPE.SYSTEM_ACTION:
          this.handleSystemAction(info);
          this.urlClickReport(updateTypeActionUrl);
          break;
      }
    },
    /**
     * 系统事件点击
     * @param {*} info
     */
    handleSystemAction(info) {
      console.log('info', info);
      const type = info?.meta?.type;
      if (!type) {
        this.$Toast('暂不支持的type类型');
        return;
      }
      switch (type) {
        // 退出排队
        case 1:
          globalWin.exitQueue();
          break;
        case 2:
          // 结束会话
          this.$parent.closeSession();
          break;
        case 3:
          // 主动评价
          this.$parent.activeFeedback();
          break;
        default:
          this.$Toast('暂不支持的事件类型');
          break;
      }
    },

    /**
     * 获取机器人导航菜单点击后的图文详情
     */
    async getImgTextDetail() {
      // todo 后面会从接口请求
      const xml = '<?xml version="1.0" encoding="utf-8"?> <msg brief="企点结构化消息" serviceID="115" background="#FFFFFFFF" action="web" actionData="https://qq.com">     <linear background="#FFFFFFFF" width="-2" height="-2" orientation="vertical">         <linear width="-2" height="-2" margin="20,16,20,12" margin.pc="10,8,10,6" orientation="vertical">             <linear width="-2" height="-2" margin="0,8,0,8" margin.pc="0,4,0,4" gravity="left|centerVertical">                 <text height="-2" width="420" size="28" color="#FF1E2330" width.pc="210" size.pc="10" color.pc="0xFF1E2330" maxLine="1" text="小鹿" gravity="left|centerVertical"></text>             </linear>             <linear width="-2" height="-2">                 <image width="420" height="328" width.pc="210" height.pc="164" cornerRadius="0" src="http://eamaterial-30012.picsz.qpic.cn/material/image/2852199661_4ecf237221a7728bda4013a801edfdb6"></image>             </linear>             <linear width="0" height="0" >                 <text size="28" color="#FF1E2330" maxLine="1" text="wxc0f12af109cd1049"></text>                 <text size="28" color="#FF1E2330" maxLine="1" text="pages/realname/realname"></text>             </linear>             <linear background="#FFE1E6F0" width="420" height="2" margin="0,18,0,6" width.pc="210" height.pc="1" margin.pc="0,9,0,3">             </linear>             <linear width="-2" height="-2" gravity="left|centerVertical">                 <image width="24" height="24" width.pc="12" height.pc="12" cornerRadius="0" src="https://oa.gtimg.com/demo/sdk/flex_pic/basic/pic4@3x.png"></image>                 <text height="-2" width="380" margin="6,0,0,0" size="24" color="#FFA1ABC2" width.pc="190" margin.pc="3,0,0,0" size.pc="8" color.pc="0xA1ABC2" text="上限啊啊啊啊啊啊啊啊啊啊啊啊啊" maxLine="1"></text>             </linear>         </linear>     </linear> </msg>';

      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type: this.IMSDKType.MSG_QDXML,
        time: Date.now(),
        status: 0,
        from: to,
      };

      Object.assign(msg, {
        content: {
          content: xml,
        },
      });

      const msgList = {
        [to]: [msg],
      };
      console.log('mock', msgList);
      imsdk.emit(IMSDK.EVENT.MESSAGE_RECEIVED, msgList);
    },

    /**
     * 机器人导航 跳转网页的点击上报
     */
    urlClickReport(reportData) {
      const reportMsg = {
        kfuin: Number(this.wpaDetail.kfuin),
        cid: this.to.user_id,
        user_data: `${reportData}&wpaId=${this.wpaDetail.wpaId}`,
        ctype: 4, // 通路id
      };
      this.$ajax.post(
        `${REPORT_ROBOTNAV_URLCLICK}?kfuin=${this.wpaDetail.kfuin}`,
        JSON.stringify(reportMsg),
        { headers: { 'Content-Type': 'application/json' } },
      )
        .then((res) => {
          if (+res.code !== 0) {
            console.log('机器人导航点击跳转网页上报失败', res);
          }
        })
        .catch((e) => {
          throw e;
        });
    },
  },
};
